import { render, staticRenderFns } from "./FrontCover.vue?vue&type=template&id=17fb4645&scoped=true"
import script from "./FrontCover.vue?vue&type=script&lang=js"
export * from "./FrontCover.vue?vue&type=script&lang=js"
import style0 from "./FrontCover.vue?vue&type=style&index=0&id=17fb4645&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fb4645",
  null
  
)

export default component.exports